// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CharacterAnimation_wrapper__2A2t9"};